import React, { useState } from "react";
import { Button, Grid, FormControl, InputAdornment, InputLabel, OutlinedInput, CircularProgress } from "@material-ui/core";
import { panelUsersAuthStyle } from "../../panelUsersAuthStyle";
import { useDispatch } from "react-redux";
import { crearCliente } from "../../../domain/api/ClientesApi";
import { Store } from "react-notifications-component";

export const CreateCliente = ({ create, clearData, handleCloseModal }) => {
    const classes = panelUsersAuthStyle();
    const dispatch = useDispatch();
    const [isLoanding, setisLoanding] = useState(false);
    const [Nombre, setNombre] = useState("");
    const [Celular, setCelular] = useState("");
    const [Documento, setDocumento] = useState("");

    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });

        handleCloseModal();
        create();
    };

    const crearClientes = async (request) => {
        const response = await crearCliente(dispatch, request);
        try {
            if (response) {
                handledAlert("Se creó exitosamente!", `Cliente creado con éxito!`, "success");
            } else {
                handledAlert("Ocurrió un error!", `${request.message}!`, "danger");
            }
        } catch {
            handledAlert("Ocurrió un error!", "Error interno", "danger");
        }
    };

    const crear = () => {
        const request = {
            nombre: Nombre,
            celular: Celular,
            documento: Documento
        };
        crearClientes(request);
    };
    const cancelar = async () => {
        handleCloseModal()
        setNombre("")
        setCelular("")
        setNombre("")
        setDocumento("")

    };

    return (
        <form>
            <Grid container spacing={3} style={{ textAlign: "left" }}>
                <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="nombre">Nombre</InputLabel>
                        <OutlinedInput
                            id="nombre"
                            type="nombre"
                            name='nombre'
                            value={Nombre}
                            required
                            onChange={e => {
                                setNombre(e.target.value);
                            }}
                            startAdornment={<InputAdornment position="start">-</InputAdornment>}
                            labelWidth={100}
                            style={{ borderRadius: '10px' }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="nombre">Celular</InputLabel>
                        <OutlinedInput
                            id="celular"
                            type="Celular"
                            name='celular'
                            value={Celular}
                            required
                            onChange={e => {
                                setCelular(e.target.value);
                            }}
                            startAdornment={<InputAdornment position="start">-</InputAdornment>}
                            labelWidth={100}
                            style={{ borderRadius: '10px' }}

                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="nombre">Documento</InputLabel>
                        <OutlinedInput
                            id="documento"
                            type="documento"
                            name='documento'
                            value={Documento}
                            onChange={e => {
                                setDocumento(e.target.value);
                            }}
                            startAdornment={<InputAdornment position="start">-</InputAdornment>}
                            labelWidth={100}
                            style={{ borderRadius: '10px' }}

                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className={classes.wrapper}>
                <Grid container justifyContent="center" style={{ marginTop: '10px' }}>

                    <Button
                        disabled={!Nombre || !Celular}
                        type="button"
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", width: "150px", borderRadius: '10px', marginRight: '10px',}}
                        onClick={crear}
                    >
                        Crear Cliente
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", marginRight: '10px', width: "150px", borderRadius: '10px' }}
                        onClick={cancelar}
                    >
                        Cancelar
                    </Button>
                </Grid>
                {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
        </form>
    );
};
